import { urlProduct } from "./urls"

export const messagesCreateProducts = { 
    type : 'createProduct',
    url : urlProduct,
    messageTextsOK : {
        messageTitle : 'Producto guardado con éxito',
        buttonLeft : 'Añadir otro producto',
        buttonRight: 'Volver a productos'
    },
    messageTextsKO : {
        messageTitle : 'Ha habido un error, intentelo de nuevo',
        buttonLeft : '',
        buttonRight: 'Volver a productos'
    }
}
export const messagesEditProducts = { 
    type : 'createProduct',
    url : urlProduct,
    messageTextsOK : {
        messageTitle : 'Producto editado con éxito',
        buttonLeft : '',
        buttonRight: 'Volver a productos'
    },
    messageTextsKO : {
        messageTitle : 'Ha habido un error, intentelo de nuevo',
        buttonLeft : '',
        buttonRight: 'Volver a productos'
    }
}